import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { MessageCircle } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { Eyebrow } from "@/components/site/ui";
import { FAQ, CONTACT, waLink } from "@/data/site";

export default function FaqSection() {
  return (
    <section className="relative py-20 sm:py-28">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <Reveal className="text-center">
          <Eyebrow className="justify-center">Sıkça Sorulan Sorular</Eyebrow>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl font-extrabold">Aklında mı kaldı?</h2>
          <p className="mt-4 text-slate-300">Merak ettiklerini yanıtladık. Cevabı bulamazsan bize WhatsApp'tan yaz.</p>
        </Reveal>

        <Reveal delay={0.1} className="mt-12">
          <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
            {FAQ.map((item, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b-0 rounded-2xl bg-ink-700 border border-white/10 px-6 data-[state=open]:border-neon-magenta/40 transition-colors"
              >
                <AccordionTrigger className="hover:no-underline py-5 text-left font-display text-lg font-bold [&>svg]:text-neon-magenta">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-300 text-base leading-relaxed pb-6">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>

        <Reveal delay={0.15} className="mt-10 text-center">
          <a
            href={waLink(CONTACT.phoneRaw, "Merhaba, birkaç sorum var, bilgi almak istiyorum.")}
            target="_blank" rel="noreferrer"
            data-testid="faq-whatsapp-cta"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full glass border border-white/15 text-white font-semibold hover:bg-white/10 transition-colors"
          >
            <MessageCircle className="w-4 h-4 text-green-400" /> Başka sorum var
          </a>
        </Reveal>
      </div>
    </section>
  );
}
